export const TTS_SERVICE = 'https://ilxgpu1000.inoviaai.se/api/v2/tts'
